<template>
<div class="flex justify-end items-center relative z-30">
  <!-- <div
    class="relative w-full align-left outline-none leading-8"
    tabindex=0
    @blur="open = false"

  >
    <div
      class="rounded-md shadow-md pl-4 text-left bg-beige-academy-100
            cursor-pointer w-56 text-sm text-grey-academy-800 font-sans-serif"
      :class="{open: open}"
      @click="open = !open"
    >
    </div>
    <div
      class="text-chocolate-academy-600 bg-white rounded-b-md shadow-md overflow-hidden text-left
            absolute w-full z-10 text-sm font-sans-serif"
      :class="{selectHide: !open}"
    >
      <div
        class="item text-chocolate-academy-600 pl-4 cursor-pointer border-t
        border-grey-academy-800 text-sm font-sans-serif"
      >
      </div>
    </div>
  </div> -->
  <md-field >
    <md-select v-model="selected" md-dense
      :class="isTeacher ? 'bg-white text-black border-2' :
      'bg-white text-black border-2'"
      class="flex w-auto relative capitalize font-sans-serif pl-2">
      <md-option v-for="(option, i) of options"
        :key="i" :value="option"
        class=" capitalize font-sans-serif bg-white"
        :class="isTeacher ? 'hover:bg-beige-academy-250 hover:text-chocolate-academy-600' :
        'hover:bg-orange-academy-150 hover:text-white'">
        {{ option }}
      </md-option>
    </md-select>
  </md-field>
  <!--<md-menu class="" md-size="small" md-align-trigger>
    <md-button md-menu-trigger :class="isTeacher ? 'bg-orange-academy-300 text-white' :
      'bg-beige-academy-100 text-chocolate-academy-600'"
      class="flex w-auto relative capitalize font-sans-serif">
        <div class="mr-6">
          {{ selected }}
        </div>
        <div class="pointer-events-none absolute inset-y-0
          right-0 flex items-center pt-1 text-grey-academy-800">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657
              8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
            </svg>
        </div>
    </md-button>
    <md-menu-content>
      <md-menu-item v-for="(option, i) of options"
        :key="i" @click="changeTimezone(option)"
        class=" capitalize font-sans-serif bg-white
        backdrop-filter backdrop-blur-lg backdrop-opacity-10">
        {{ option }}
      </md-menu-item>
    </md-menu-content>
  </md-menu> -->
</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['options'],

  data() {
    return {
      open: false,
      selected: '',
    };
  },

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
      isTeacher: 'auth/isTeacher',
    }),
  },

  mounted() {
    this.selected = this.choosenTimezone;
  },

  watch: {
    selected() {
      this.changeTimezone();
    },

    choosenTimezone() {
      this.selected = this.choosenTimezone;
    },
  },

  methods: {
    ...mapActions({
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),

    changeTimezone() {
      this.setChoosenTimezone(this.selected);
      dayjs.tz.setDefault(this.selected);
    },
  },
};
</script>
